export default __webpack_public_path__ + "static/25-46121da513cd0837c8f064495bcb010e.gif";